import styles from './LayoutWrapper.module.scss';

export default function LayoutWrapperComponent({ children }) {
    return (
        <div className={styles.redlLayoutWrapper}>
            { children }
        </div>
    );
}